import React from 'react';

import { Money, formatMoney } from '@betterment/core';
import { HStack, Text, VStack } from '@betterment/samba-react';

import { TaxLossHarvestingSetupLink } from './Links';

import { TaxLossHarvestingPerformanceModal } from '../../../Shared/components-v2/tax-loss-harvesting/TaxLossHarvestingPerformanceModal';
import { TaxLossHarvestingToggletip } from '../../../Shared/components-v2/tax-loss-harvesting/TaxLossHarvestingToggletip';

type Props = {
  taxLossesHarvested?: Money | null;
  allTimeEstimatedTaxSavings?: Money | null;
};

export const TaxLossHarvestingRow: React.FC<Props> = ({ taxLossesHarvested, allTimeEstimatedTaxSavings }) => {
  if (!taxLossesHarvested) {
    return (
      <HStack css={{ justifyContent: 'space-between' }}>
        <HStack>
          <Text>Tax loss harvesting</Text>
          <TaxLossHarvestingToggletip isEnabled={false} />
        </HStack>
        <TaxLossHarvestingSetupLink />
      </HStack>
    );
  }

  if (taxLossesHarvested.cents === 0) {
    return (
      <HStack css={{ justifyContent: 'space-between' }}>
        <HStack>
          <Text>Tax loss harvesting</Text>
          <TaxLossHarvestingToggletip isEnabled={true} />
        </HStack>
        <Text>Active</Text>
      </HStack>
    );
  }

  if (allTimeEstimatedTaxSavings) {
    return (
      <HStack css={{ justifyContent: 'space-between' }}>
        <VStack>
          <Text>Estimated tax savings</Text>
          <TaxLossHarvestingPerformanceModal />
        </VStack>
        <Text css={{ pl: 'space.300', fontVariantNumeric: 'tabular-nums' }}>
          {formatMoney(allTimeEstimatedTaxSavings)}
        </Text>
      </HStack>
    );
  }

  return null;
};
